module.exports = {
  input: require('./input'),
  output: require('./output')
}



//////////////////
// WEBPACK FOOTER
// ./~/htmlcoinjs-lib/~/bitcoinjs-lib/src/templates/multisig/index.js
// module id = F52w
// module chunks = 0